export const breakpoints = {
  xs: 338,
  sm: 686,
  md: 1024,
  lg: 1220,
  xl: 1440,
};
